import { Path } from '@/main/router/routerPath';

import { CorporateSegment } from './CorporateSegment';
import { NationalAccount } from './NationalAccount';
import DealersCPFFormList from './DealersCPF/pages/DealersCPFFormList.vue';
import { DealersCPF } from './DealersCPF';
import { CPF } from './CPF';
import { CorporateProfile } from './CorporateProfile';
import { NationalCPF } from './NationalCPF';
import { CorporateAccountRequestStatus } from './CorporateAccountRequestStatus';
import { ApprovalWorkflow } from './ApprovalWorkflow';
import { FollowupEmailConfig } from './FollowupEmailConfig';
import CorporateAccountRequestStatusList from './CorporateAccountRequestStatus/pages/CorporateAccountRequestStatusList.vue';

export const router = new Path('OEM').addChildren([
	new Path('DealersCPFForm', { List: DealersCPFFormList }, 'OEM_DealersCPFForm', 'DealersCPFForm'),
	NationalAccount.router,
	NationalCPF.router,
	CPF.router,
	CorporateProfile.router,
	DealersCPF.router,
	CorporateAccountRequestStatus.router,
	ApprovalWorkflow.router,
	new Path('CorporateAccountRequestStatusList', { List: CorporateAccountRequestStatusList }, 'OEM_CorporateAccountRequestStatusForm', 'CorporateAccountRequestStatusList'),
	CorporateAccountRequestStatus.router,
	CorporateSegment.router,
	FollowupEmailConfig.router,
]);
